module.exports = __webpack_public_path__ + "static/media/services-31.d141fbee.png";